// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Rtet","header":"PatientQuestionnaire_header__3PmSL","info":"PatientQuestionnaire_info__2t2Jn"};